<template>
  <v-container fluid>
    <v-card-title class="teal lighten-3 accent-4 white--text">
      Confirmacion de pedidos
      <v-spacer />
      <v-col cols="12" md="4">
        <v-text-field
          @input="filtrarItems"
          v-model="search"
          append-icon="mdi-magnify"
          label="Búsqueda"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-card-title>

    <v-tabs v-model="selectedTab" color="teal lighten-3 accent-4" left>
      <v-tab
        v-for="(sucursal, index) in itemsSucursalesDisponibles"
        :key="index"
      >
        <div v-if="(sucursal, index) in ordenSucursales" :key="index"></div>
        <div>
          {{ sucursal.sucursal }}
        </div>
      </v-tab>
      <v-tab-item
        :disabled="true"
        v-for="(sucursal, index) in itemsNombre"
        :key="index"
      >
        <v-data-table
          :headers="headers"
          :items="selectedItems"
          :search="search"
          v-model="selectedPedidos"
          checkbox-color="blue darken-1"
          :footer-props="{
            'items-per-page-text': 'Pedidos por página',
            'items-per-page-all-text': 'Todos',
          }"
          :header-props="{ 'sort-by-text': 'Ordenar por' }"
          :item-class="itemRowBackgroundPrioridad"
          no-data-text="No se encontraron pedidos"
          no-results-text="No se encontraron pedidos"
          @dblclick:row="selectPedido"
          @current-items="currentItems"
          @click:row="abrirVistaConfirmacion"
        >
          <!-- Columna de Lista plegable de productos -->
          <template v-slot:[`item.lista_productos`]="{ item }">
            <v-list-group v-bind:class="itemRowBackground(item)">
              <template v-slot:activator> </template>
              <v-list-item
                v-for="producto in item.productos.lista_productos"
                :key="producto.codigo"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      producto.codigo +
                      " " +
                      producto.nombre +
                      ": " +
                      producto.cantidad
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </template>
          <!-- Columna de total -->
          <template v-slot:[`item.total`]="{ item }">
            {{ "$" + formatoPrecio(item.total) }}
          </template>
          <!-- Columna de antiguedad -->
          <template v-slot:[`item.fecha_creacion`]="{ item }">
            {{ getAntiguedad(item.fecha_creacion) }}
          </template>
          <!-- Columna de discrepancias -->
          <template v-slot:[`item.discrepancias`]="{ item }">
            <div v-if="item.discrepancias === 'Sin discrepancias'">
              Sin discrepancias
            </div>
            <v-list-group v-else v-bind:class="itemRowBackground(item)">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <v-btn icon color="warning" text>
                      <v-icon dark> mdi-alert-outline </v-icon>
                    </v-btn>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="discrepancia in crearListaDiscrepancias(
                  item.discrepancias
                )"
                :key="discrepancia"
                no-action
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ discrepancia }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </template>
          <!-- Columna de Lista plegable de facturas -->
          <template v-slot:[`item.facturas`]="{ item }">
            <div v-if="item.facturas.length != 0">
              <div v-if="item.facturas.length === 1">
                {{ item.facturas[0] }}
              </div>
              <v-list-group
                v-if="item.facturas.length > 1"
                v-bind:class="itemRowBackground(item)"
              >
                <template v-slot:activator> </template>
                <v-list-item v-for="factura in item.facturas" :key="factura">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ factura }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </div>
            <div v-else>Sin facturas</div>
            <!-- <div v-if="item.facturas.length === 0">Sin facturaszz</div>
              <div v-else>{{ item.facturas[0] }}</div> -->
          </template>
          <!-- Columna de estado -->
          <template v-slot:[`item.estado`]="{ item }">
            <v-chip color="primary" small>
              {{ item.estado }}
            </v-chip>
          </template>

          <template v-slot:[`item.necesitaRevision`]="{ item }">
            <v-chip v-if="item.necesitaRevision" color="red" small>
              {{ item.necesitaRevision }}
            </v-chip>
          </template>

          <!-- Columna de avanzar a: -->
          <template v-slot:[`item.avanzar_a`]="{ item }">
            <div
              v-if="item.estado === 'Cancelado' || item.estado === 'Entregado'"
            >
              N/A
            </div>

            <v-btn v-else @click="confirmarAvanzarPedido(item)" x-small>
              {{ getSiguienteEstado(item).text }}
            </v-btn>
          </template>
          <!-- Columna de acciones -->
          <template v-slot:[`item.acciones`]="{ item }">
            <template v-if="arrayComentariosNuevos.includes(item.id)">
              <v-badge color="red" dot overlap>
                <AccionesPedido
                  :item="item"
                  :usuarios="usuarios"
                  @pedidoModificado="pedidoModificado"
                />
              </v-badge>
            </template>
            <template v-else>
              <AccionesPedido
                :item="item"
                :usuarios="usuarios"
                @pedidoModificado="pedidoModificado"
              />
            </template>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
    <!-- Dialogo para abrir vista de detalles de un pedido de confirmacion -->
    <v-dialog
      v-model="abrirDetallesConfirmacion"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title class="text-center">
          <v-spacer></v-spacer>
          <v-btn
            icon
            color="blue darken-1"
            text
            @click="cerrarDialogDetallesConfirmacion()"
          >
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6">
              <h3>Detalles del pedido</h3>
              <p><strong>ID:</strong> {{ pedidoSeleccionado?.id }}</p>
              <p>
                <strong> Cliente:</strong> {{ pedidoSeleccionado?.cliente }}
              </p>
              <p><strong>Zona:</strong> {{ pedidoSeleccionado?.zona }}</p>
              <p>
                <strong>Vendedor:</strong> {{ pedidoSeleccionado?.vendedor }}
              </p>
              <p>
                <strong>Observaciones:</strong>
                {{ pedidoSeleccionado?.observaciones }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex align-center justify-center">
              <div class="d-flex flex-column align-center justify-center">
                <div
                  v-if="
                    pedidoSeleccionado?.estado === 'Cancelado' ||
                    pedidoSeleccionado?.estado === 'Entregado'
                  "
                >
                  N/A
                </div>
                <v-btn
                  :disabled="!todosProductosMarcados"
                  v-if="
                    pedidoSeleccionado && getSiguienteEstado(pedidoSeleccionado)
                  "
                  @click="confirmarAvanzarPedido(pedidoSeleccionado)"
                  x-small
                >
                  confirmar y avanzar a:
                  {{ getSiguienteEstado(pedidoSeleccionado).text }}
                </v-btn>
                <v-btn
                  :disabled="!todosProductosMarcados"
                  x-small
                  class="my-7"
                  color="primary"
                  @click="generarComentariosProductos()"
                  >Crear comentarios faltantes</v-btn
                >
              </div>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <v-card>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h3>Comentarios nuevos</h3>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <h3>Comentarios</h3>
                  <div
                    v-if="comentariosDelPedido.length === 0"
                    class="text-grey text-center py-4"
                  >
                    No hay comentarios
                  </div>

                  <div
                    v-else
                    class="d-flex flex-column ga-2"
                    style="max-height: 300px; overflow-y: auto"
                  >
                    <div
                      v-for="(comentario, i) in comentariosDelPedido"
                      :key="i"
                      class="chat-bubble ml-4"
                    >
                      <strong>Comentario: </strong>
                      {{ comentario.texto_comentario }}
                      <br />
                      <strong>Realizado por:</strong>
                      {{ getVendedor(comentario.usuario) }} <br />
                      <strong>Fecha: </strong>
                      <small class="text-grey">{{
                        getFechaLegible(comentario.fecha_creacion)
                      }}</small>
                      <v-divider class="my-2" color="grey"></v-divider>
                    </div>
                  </div>

                  <v-btn
                    class="d-flex align-center justify-center"
                    @click="agregarComentario = true"
                    color="primary"
                  >
                    Agregar comentario
                  </v-btn>
                  <v-col cols="12" v-if="agregarComentario">
                    <v-textarea
                      v-model="nuevoComentario"
                      label="Agregar comentario"
                      outlined
                    ></v-textarea>
                    <v-btn color="primary" @click="crearComentario()">
                      <v-icon>mdi-send</v-icon>
                      Enviar
                    </v-btn>
                  </v-col>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>

          <v-divider class="my-4"></v-divider>

          <h3>Productos</h3>
          <v-list dense>
            <v-list-item
              v-for="producto in pedidoSeleccionado?.productos?.lista_productos"
              :key="producto.codigo"
            >
              <v-col cols="12" class="d-flex align-center flex-wrap">
                <v-col cols="6">
                  {{ producto.codigo }} - {{ producto.nombre }} <br />
                  <div class="text-left">
                    Cantidad: {{ producto.cantidad }}
                    {{ producto.codigo.includes("OF") ? "Paquete(s)" : "" }}
                  </div>
                  <!-- Productos secundarios -->
                  <v-list dense class="pa-0">
                    <v-list-item
                      v-for="secundario in producto.productosPaquete"
                      :key="secundario.codigo"
                      class="py-1 px-2"
                    >
                      <h4 class="ma-0">
                        • {{ secundario.codigo }} - {{ secundario.nombre }}
                      </h4>
                      <span class="ml-2"
                        >Cantidad:
                        {{ secundario.cantidad * producto.cantidad }}</span
                      >
                    </v-list-item>
                  </v-list>
                </v-col>

                <v-spacer></v-spacer>
                <v-card
                  class="d-flex align-center justify-center ml-2"
                  elevation="2"
                >
                  <v-btn
                    v-if="producto.estado !== 'No valido'"
                    icon
                    x-large
                    color="green"
                    @click="marcarComoValido(producto)"
                    :class="[
                      producto.bloqueado || botonBloqueado === producto.id
                        ? 'bg-green-lighten-3 pointer-disabled'
                        : 'bg-green-darken-2',
                      'text-white',
                    ]"
                  >
                    <v-icon>mdi-check</v-icon></v-btn
                  >

                  <v-btn
                    v-if="producto.estado !== 'Valido'"
                    icon
                    x-large
                    color="red"
                    @click="abrirDialogoCantidad(producto)"
                    class="ml-2"
                    :class="[
                      producto.bloqueado
                        ? 'bg-red-lighten-3 pointer-disabled'
                        : 'bg-red-darken-2',
                      'text-white',
                    ]"
                  >
                    <v-icon>mdi-close</v-icon></v-btn
                  >
                </v-card>

                <v-col
                  cols="3"
                  v-if="
                    producto.estado === 'No valido' &&
                    producto.cantidadReal !== null
                  "
                >
                  <span class="text-caption red--text"
                    >Cantidad Fisica: {{ producto.cantidadReal }}</span
                  >
                </v-col>
                <v-col cols="3" v-if="producto.estado === 'Valido'">
                  <span class="text-caption white--text"
                    >.................
                  </span>
                </v-col>
                <v-btn
                  v-if="producto.bloqueado"
                  icon
                  @click="habilitarEdicion(producto)"
                  color="primary"
                >
                  <v-icon>mdi-pencil</v-icon></v-btn
                >
              </v-col>
            </v-list-item>
            <v-dialog v-model="dialogCantidadGlobal" max-width="400px">
              <v-card>
                <v-card-title>
                  Ingrese cantidad de
                  {{ productosSeleccionadoParaDialog?.codigo }}:
                </v-card-title>
                <v-card-text>
                  <v-text-field
                    v-if="productosSeleccionadoParaDialog"
                    v-model.number="
                      productosSeleccionadoParaDialog.cantidadReal
                    "
                    label="Cantidad correcta"
                    type="number"
                    dense
                    hide-details
                    min="0"
                  >
                  </v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="confirmarCantidad"
                    >Aceptar</v-btn
                  >
                  <v-btn color="grey" text @click="cancelarDialogoCantidad"
                    >Cancelar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-list>
        </v-card-text>
      </v-card>
      <!-- dialog para confirmar comentario generado-->
      <v-dialog v-model="dialogoComentariosGenerados" max-width="600">
        <v-card>
          <v-card-title class="headline"
            >¿Deseas confirmar los comentarios?</v-card-title
          >
          <v-card-text>
            <p>Verifica los comentarios generados:</p>
            <v-textarea
              v-model="textoComentariosGenerados"
              outlined
              rows="5"
              label="Comentarios generados"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="cancelarConfirmacion">Cancelar</v-btn>
            <v-btn color="primary" @click="confirmarDialogo">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>

    <!-- Dialogo para agregar mensajero -->
    <v-dialog v-model="dialogUsuariosGPS" max-width="500px">
      <v-card>
        <v-card-title> Agregar mensajero </v-card-title>
        <v-card-text>
          <v-select
            label="Mensajero"
            v-model="mensajero"
            :items="mensajeros"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            :disabled="!mensajero"
            text
            @click="avanzarRutaEntrega"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog para confirmar el avance de un pedido -->
    <v-dialog v-model="dialogConfirmarAvanzar" max-width="500px">
      <v-card>
        <v-card-title> ¿Avanzar el pedido? </v-card-title>
        <v-card-actions>
          <v-btn color="primary" text @click="avanzarPedido(pedidoAvanzar)">
            Avanzar
          </v-btn>
          <v-btn color="primary" text @click="dialogConfirmarAvanzar = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog para confirmar el avance de multiples pedidos -->
    <v-dialog
      v-model="dialogConfirmarAvanzarVarios"
      max-width="500px"
      scrollable
    >
      <v-card>
        <v-card-title>
          ¿Avanzar los pedidos?
          <v-spacer></v-spacer>
          <div v-if="selectedPedidos.length > 0">
            <v-btn
              v-if="selectedPedidos[0].estado === 'Preparado'"
              color="primary"
              x-small
              @click="agregarMensajeroVarios"
            >
              Agregar mensajero
            </v-btn>
          </div>
        </v-card-title>
        <div v-if="selectedPedidos.length > 0">
          <v-subheader v-if="selectedPedidos[0].estado === 'Facturación'"
            >Asegurate que todos los pedidos cuentan con una factura asociada
          </v-subheader>
        </div>
        <v-divider></v-divider>
        <v-card-text style="height: 300px">
          <!-- <v-list>
              <v-list-item v-for="item in selectedPedidos" :key="item.id">
                <v-list-item-content>
                  <v-list-item-title>{{
                    item.id + " - " + item.cliente
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list> -->
          <v-data-table
            :headers="headersAvanzarPedidos"
            :items="selectedPedidos"
            hide-default-header
            hide-default-footer
            :items-per-page="-1"
            dense
          ></v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="avanzarVariosPedidos">
            Avanzar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="dialogConfirmarAvanzarVarios = false"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog para mostrar el progreso de multiples pedidos -->
    <v-dialog
      v-model="dialogProgresoAvanzarVarios"
      max-width="500px"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title>Avanzando pedidos</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px">
          <v-data-table
            :headers="headersAvanzandoPedidos"
            :items="pedidosConEstadoSolicitud"
            hide-default-header
            hide-default-footer
            :items-per-page="-1"
            dense
          >
            <!-- Columna del estado de solicitud -->
            <template v-slot:[`item.solicitud`]="{ item }">
              <v-chip
                v-if="item.solicitud === 'En espera...'"
                color="primary"
                small
              >
                {{ item.solicitud }}
              </v-chip>
              <v-progress-circular
                v-if="item.solicitud === 'Procesando...'"
                :size="20"
                :width="3"
                indeterminate
                color="primary"
              ></v-progress-circular>
              <v-icon
                v-if="item.solicitud === 'Completado'"
                color="green"
                size="20"
                >mdi-check-circle</v-icon
              >
              <v-icon
                v-if="item.solicitud === 'No completado'"
                color="red"
                size="20"
                >mdi-close-circle</v-icon
              >
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            :disabled="AvanzandoPedidosBtn"
            text
            @click="dialogProgresoAvanzarVarios = false"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog para agregar mensajero individualmente avanzando varios pedidos-->
    <v-dialog v-model="dialogUsuariosGPSVarios" max-width="500px" scrollable>
      <v-card>
        <v-card-title> Agregar mensajero a los pedidos</v-card-title>
        <v-card-text>
          <div v-for="pedido in pedidosConEstadoSolicitud" :key="pedido.id">
            <p>{{ pedido.id }} - {{ pedido.cliente }}</p>
            <v-select
              v-model="pedido.nuevoMensajero"
              :items="mensajeros"
              label="Mensajero"
            ></v-select>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="avanzarRutaEntregaVarios"
            :disabled="!todosMensajerosSeleccionados"
            >Agregar</v-btn
          >
          <v-btn color="primary" text @click="dialogUsuariosGPSVarios = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog para agregar el mismo mensajero a varios pedidos preparados-->
    <v-dialog v-model="dialogAgregarMensajeroAll" max-width="500px" scrollable>
      <v-card>
        <v-card-title> Agregar mensajero a todos los pedidos</v-card-title>
        <v-card-text>
          <v-subheader>
            Este mensajero se asignará a todos los pedidos seleccionados
          </v-subheader>
          <v-select
            v-model="mensajeroParaVariosPreparados"
            :items="mensajeros"
            label="Mensajero"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="avanzarVariosPreparados"
            :disabled="!mensajeroParaVariosPreparados"
            >Agregar y avanzar</v-btn
          >
          <v-btn
            color="primary"
            text
            @click="dialogAgregarMensajeroAll = false"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AccionesPedido from "@/components/AccionesPedido.vue";
import axios from "axios";
import { format, subMinutes, subHours } from "date-fns";

export default {
  props: ["items", "usuarios", "clientes"],
  data() {
    return {
      dialogoComentariosGenerados: false,
      textoComentariosGenerados: "",
      resolverConfirmacion: null, //una promesa que se resuelve cuando se confirma el metodo y continuar
      botonBloqueado: null,
      dialogCantidadGlobal: false,
      productosSeleccionadoParaDialog: null,
      agregarComentario: false,
      nuevoComentario: "",
      abrirDetallesConfirmacion: false,
      pedidoSeleccionado: null,
      comentariosDelPedido: [],
      confirmarEnvio: false,
      formatoSeleccionado: null,
      selectedTab: 0,
      pedidoAvanzar: null, //almacena el pedido que se va a avanzar en el dialog de dialogConfirmarAvanzar
      selectedPedidos: [], //almacena los pedidos seleccionados para avanzarlos juntos
      pedidosConEstadoSolicitud: [], //almacena los pedidos con estado de solicitud para mostrar su progreso
      search: "",
      filtroEstado: "",
      itemsActuales: [],
      headers: [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Cliente",
          value: "cliente",
        },
        /*{
          text: "Total",
          value: "total",
        },
        {
          text: "Lista de productos",
          value: "lista_productos",
          sortable: false,
        },
        {
          text: "Pago",
          value: "pago",
        },
        {
          text: "Vendedor",
          value: "vendedor",
        },*/
        {
          text: "Zona",
          value: "zona",
        },
        {
          text: "Antigüedad",
          value: "fecha_creacion",
        },
        /*
        {
          text: "Discrepancias",
          value: "discrepancias",
        },
        {
          text: "Facturas",
          value: "facturas",
        },*/
        {
          text: "Estado",
          value: "estado",
          filter: (value) => {
            if (!this.filtroEstado);

            return value === "Confirmación";
          },
          class: "d-none",
          cellClass: "d-none",
        },

        {
          text: "Necesita revisión",
          value: "necesitaRevision",
          sortable: false,
          class: "d-none",
          cellClass: "d-none",
        },
        {
          text: "Avanzar a:",
          value: "avanzar_a",
          sortable: false,
          class: "d-none",
          cellClass: "d-none",
        },
      ],
      headersAvanzarPedidos: [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Cliente",
          value: "cliente",
        },
      ],
      headersAvanzandoPedidos: [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Cliente",
          value: "cliente",
        },
        {
          text: "Solicitud",
          value: "solicitud",
          align: "center",
        },
      ],
      ordenSucursales: [
        "Mexicali",
        "Tijuana",
        "Ensenada",
        "LaPaz",
        "Obregon",
        "Hermosillo",
      ],
      ordenEstados: [
        {
          text: "Pedido creado",
          value: "pedido_creado",
        },
        {
          text: "Confirmación",
          value: "confirmacion",
        },
        {
          text: "Facturación",
          value: "facturacion",
        },
        {
          text: "Preparación en almacén",
          value: "preparacion_en_almacen",
        },
        {
          text: "Preparado",
          value: "preparado",
        },
        {
          text: "En ruta de entrega",
          value: "en_ruta_de_entrega",
        },
        {
          text: "Entregado",
          value: "entregado",
        },
      ],
      listaEstados: [
        {
          text: "Sin filtro",
          value: "",
        },
        {
          text: "Pedido creado",
        },
        {
          text: "Revisión de crédito",
        },
        {
          text: "Confirmación",
        },
        {
          text: "Facturación",
        },
        {
          text: "Preparación en almacén",
        },
        {
          text: "Preparado",
        },
        {
          text: "En ruta de entrega",
        },
      ],
      estadosPedidos: [
        "Pedido creado",
        "Revisión de crédito",
        "Confirmación",
        "Facturación",
        "Preparación en almacén",
        "Preparado",
        "En ruta de entrega",
      ],
      RutaFormatos: [
        {
          text: "ID Pedido",
          value: "pedidosPreparadosIDs",
          sortable: false,
        },
        {
          text: "Cliente",
          value: "clientes",
          sortable: false,
        },
        {
          text: "Mensajero",
          value: "mensajero",
          sortable: false,
        },
      ],
      estadosSelected: ["Preparado"],
      itemsSucursalesDisponibles: [],
      itemsFiltrados: [],
      itemsPedidos: this.items,
      dialogUsuariosGPS: false,
      dialogConfirmarAvanzar: false,
      dialogConfirmarAvanzarVarios: false,
      dialogProgresoAvanzarVarios: false,
      dialogUsuariosGPSVarios: false,
      dialogAgregarMensajeroAll: false,
      dialogPedidosSinLocalizacion: false,
      AvanzandoPedidosBtn: true,

      pedidoEnRuta: null,
      mensajero: "",
      mensajeroParaVariosPreparados: "",
      mensajeros: [],
      mensajerosImpresion: [],
      mensajeroSelected: null,
      arrayComentariosNuevos: [],
      pedidosConLocalizacion: [],
      pedidosSinLocalizacion: [],
      dialogComentarios: false,
      dialogPedidos: false,

      dialogoFormatos: false,
      formatosVisibles: 5,
      mostrarTodos: false,

      sucursalesDirecciones: {},
    };
  },
  methods: {
    async verificarProductosConOF() {
      const sucursal = this.pedidoSeleccionado?.sucursal; // Asegúrate de tener la sucursal disponible

      for (const producto of this.pedidoSeleccionado.productos
        .lista_productos) {
        if (producto.codigo.includes("OF")) {
          try {
            const productosSecundarios = await this.getProductosPaquetes(
              producto.codigo,
              sucursal
            );
            this.$set(producto, "productosPaquete", productosSecundarios); // Agrega los productos secundarios al producto principal
          } catch (error) {
            console.error(
              `Error al obtener los productos secundarios para el código ${producto.codigo}:`,
              error
            );
          }
        }
      }
    },

    async getProductosPaquetes(codigo, sucursal) {
      try {
        const response = await axios.get(
          `/productos/get_componenes_de_paquete?codigo=${codigo}&sucursal=${sucursal} `
        );
        return response.data;
        //console.log(this.productosPaquetes);
      } catch (error) {
        console.error("Error al obtener los datos de los productos", error);
      }
    },

    abrirDialogoCantidad(producto) {
      this.productosSeleccionadoParaDialog = producto;
      this.dialogCantidadGlobal = true;
    },

    marcarComoValido(producto) {
      this.botonBloqueado = producto.id;
      this.$set(producto, "estado", "Valido");
      producto.estado = "Valido";
      producto.bloqueado = true;
      setTimeout(() => {
        this.botonBloqueado = null;
      });
    },

    confirmarCantidad() {
      const producto = this.productosSeleccionadoParaDialog;
      if (
        !producto ||
        (producto.cantidadReal !== null && producto.cantidadReal < 0)
      ) {
        alert("Ingrese una cantidad válida");
        return;
      }
      this.$set(producto, "estado", "No valido");
      producto.estado = "No valido";
      producto.bloqueado = true;
      this.dialogCantidadGlobal = false;
      this.productosSeleccionadoParaDialog = null;
    },

    cancelarDialogoCantidad() {
      this.dialogCantidadGlobal = false;
      this.productosSeleccionadoParaDialog = null;
    },

    habilitarEdicion(producto) {
      producto.bloqueado = false;
      producto.estado = null;
      producto.cantidadReal = null;
      this.$forceUpdate();
    },

    async inicializarProductos() {
      if (this.pedidoSeleccionado?.productos.lista_productos) {
        this.pedidoSeleccionado.productos.lista_productos.forEach(
          (producto) => {
            if (producto.estado === undefined)
              this.$set(producto, "estado", producto.estado || null);
            if (producto.cantidadReal === undefined)
              this.$set(producto, "cantidadReal", null);
            if (producto.bloqueado === undefined)
              this.$set(producto, "bloqueado", false);
            if (producto.dialogCantidad === undefined)
              this.$set(producto, "dialogCantidad", false);
            if (producto.productosPaquete === undefined)
              this.$set(producto, "productosPaquete", []);
          }
        );
        await this.verificarProductosConOF();
      }
    },

    abrirVistaConfirmacion(item) {
      this.pedidoSeleccionado = item;
      this.abrirDetallesConfirmacion = true;
    },

    cerrarDialogDetallesConfirmacion() {
      this.abrirDetallesConfirmacion = false;
      this.pedidoSeleccionado = null;
    },

    async obtenerComentariosDelPedido(idPedido) {
      try {
        const response = await axios.get(
          `/varios/get_comentarios?id_objeto=${idPedido}&tipo_objeto=pedido`
        );
        this.comentariosDelPedido = response.data.slice().reverse();
      } catch (error) {
        console.error("Error al obtener los comentarios del pedido:", error);
        this.comentariosDelPedido = [];
      }
    },

    async crearComentario() {
      try {
        await axios.post(
          `/varios/crear_comentario?id_objeto=${this.pedidoSeleccionado.id}&tipo_objeto=pedido&comentario=${this.nuevoComentario}`
        );
        alert("Comentario creado con éxito");
        this.nuevoComentario = ""; // Limpiar el campo de texto después de enviar el comentario
        this.agregarComentario = false; // Cerrar el diálogo de agregar comentario
        this.obtenerComentariosDelPedido(this.pedidoSeleccionado.id);
      } catch (error) {
        console.error("Error al crear el comentario:", error);
      }
    },

    validarProductos() {
      const productosNoMarcados =
        this.pedidoSeleccionado.productos.lista_productos.filter(
          (producto) => !producto.checked
        );

      if (productosNoMarcados.length === 0) {
        alert("Todos los productos han sido validados");
        return;
      }

      const nombresProductos = productosNoMarcados
        .map((producto) => `${producto.codigo} - ${producto.nombre}`)
        .join(", ");

      const comentario = `No hay stock de los siguientes productos: ${nombresProductos}`;
      this.crearComentarioAutomatico(comentario);
    },

    async crearComentarioAutomatico(comentario) {
      try {
        await axios.post(
          `/varios/crear_comentario?id_objeto=${this.pedidoSeleccionado.id}&tipo_objeto=pedido&comentario=${comentario}`
        );
        alert(
          "Validación de productos creada con éxito y comentario creado con éxito."
        );
        this.obtenerComentariosDelPedido(this.pedidoSeleccionado.id);
      } catch (error) {
        console.error("Error al crear el comentario:", error);
      }
    },

    async generarComentariosProductos() {
      const productos = this.pedidoSeleccionado.productos.lista_productos;

      const comentarios = [];

      productos.forEach((prod) => {
        if (prod.estado === "Valido" || prod.cantidadReal === null) {
          // Se validó como correcto, no requiere comentario
          return;
        }

        if (prod.estado === "No valido" && prod.cantidadReal !== null) {
          comentarios.push(
            `El producto ${prod.codigo} (${prod.nombre}) tenía solicitados: ${prod.cantidad}, pero solo hay: ${prod.cantidadReal} en stock.`
          );
        }
      });

      if (comentarios.length === 0) {
        alert("No hay comentarios que generar.");
        return;
      }

      this.textoComentariosGenerados = comentarios.join(", ");
      const confirmado = await this.mostrarDialogComentariosConfirmacion();
      if (!confirmado) {
        return;
      }

      try {
        await axios.post("/varios/crear_comentario", null, {
          params: {
            id_objeto: this.pedidoSeleccionado.id,
            tipo_objeto: "pedido",
            comentario: this.textoComentariosGenerados,
          },
        });

        alert("Comentarios creados correctamente.");
        this.obtenerComentariosDelPedido(this.pedidoSeleccionado.id);
      } catch (error) {
        console.error("Error al crear comentarios:", error);
        alert("Hubo un problema al crear comentarios.");
      }
    },

    //funcion que muestra el dialog y espera confirmacion
    mostrarDialogComentariosConfirmacion() {
      this.dialogoComentariosGenerados = true;

      return new Promise((resolve) => {
        this.resolverConfirmacion = resolve;
      });
    },

    confirmarDialogo() {
      this.dialogoComentariosGenerados = false;
      if (this.resolverConfirmacion) {
        this.resolverConfirmacion(true);
        this.resolverConfirmacion = null;
      }
    },

    cancelarConfirmacion() {
      this.dialogoComentariosGenerados = false;
      if (this.resolverConfirmacion) {
        this.resolverConfirmacion(false);
        this.resolverConfirmacion = null;
      }
    },

    getVendedor(vendedorId) {
      const vendedorEncontrado = this.usuarios.find(
        (usuario) => usuario.id === vendedorId
      );
      if (vendedorEncontrado) {
        return vendedorEncontrado.nombre + " ";
      }
      return "";
    },

    abrirDialogoConfirmacion(formato) {
      this.formatoSeleccionado = formato;
      this.confirmarEnvio = true;
    },

    cerrarDialogoConfirmacion() {
      this.confirmarEnvio = false;
      this.formatoSeleccionado = null;
    },

    confirmarActualizarPedidos() {
      if (this.formatoSeleccionado) {
        this.actualizarPedidosARuta(this.formatoSeleccionado);
      }
      this.cerrarDialogoConfirmacion();
    },

    obtenerSucursalActual() {
      const nombreSucursal = this.ordenSucursales[this.selectedTab];
      return this.sucursalesDirecciones[nombreSucursal] || {};
    },

    calcularTotalDePedidos() {
      //calcular el total de los pedidos de cada estado

      return this.pedidos.reduce((total, pedido) => total + pedido.total, 0);
    },

    mostrarMasFormatos() {
      this.formatosVisibles += 5;
      this.mostrarTodos = true;
    },

    ocultarFormatos() {
      this.formatosVisibles = 5;
      this.mostrarTodos = false;
    },

    obtenerMensajeroConGps() {
      const sucursalActiva = this.ordenSucursales[this.selectedTab];

      this.mensajerosImpresion = this.usuarios
        .filter(
          (usuario) =>
            usuario.gps !== null && usuario.sucursal === sucursalActiva
        )
        .map((mensajero) => ({
          text: mensajero.nombre,
          value: mensajero.id,
        }));
    },

    selectPedido(event, rowInfo) {
      // Comprobamos si el objeto ya existe en el array
      const index = this.selectedPedidos.findIndex(
        (pedido) => pedido.id === rowInfo.item.id
      );

      if (index !== -1) {
        // Si el objeto ya existe, lo eliminamos del array
        this.selectedPedidos.splice(index, 1);
      } else {
        // Si no existe, lo agregamos al array
        this.selectedPedidos.push(rowInfo.item);
      }

      console.log(this.selectedPedidos);
    },
    agregarMensajeroVarios() {
      const mensajerosArray = this.usuarios.filter(
        (usuario) =>
          usuario.sucursal === this.selectedPedidos[0].sucursal &&
          usuario.gps !== null
      );
      console.log(mensajerosArray);

      this.mensajeros = mensajerosArray.map((mensajero) => ({
        text: mensajero.nombre,
        value: mensajero.id,
      }));

      this.dialogAgregarMensajeroAll = true;
    },
    async avanzarVariosPreparados() {
      console.log(this.mensajeroParaVariosPreparados);
      console.log("se avanzan los pedidos");
      // se le asigna el estado 'en espera...' a todos los pedidos. Ese estado se ira modificando comforme se avancen los pedidos
      const pedidosEstadoSolicitud = this.selectedPedidos.map((pedido) => {
        const pedidoEstadoSolicitud = { ...pedido };
        pedidoEstadoSolicitud.solicitud = "En espera...";
        return pedidoEstadoSolicitud;
      });
      this.pedidosConEstadoSolicitud = pedidosEstadoSolicitud;

      this.dialogConfirmarAvanzarVarios = false;
      this.dialogAgregarMensajeroAll = false;
      this.dialogProgresoAvanzarVarios = true;
      this.AvanzandoPedidosBtn = true;

      // for (let i = 0; i < this.pedidosConEstadoSolicitud.length; i++) {
      //   // Cambiar el estado del objeto en el array
      //   this.pedidosConEstadoSolicitud[i].solicitud = "Procesando...";

      //   // Simular solicitud al backend esperando 5 segundos
      //   await new Promise((resolve) => setTimeout(resolve, 500));

      //   // Cambiar el estado del objeto en el array
      //   this.pedidosConEstadoSolicitud[i].solicitud = "Completado";

      //   // Imprimir el estado actual después de cambiarlo
      //   console.log(
      //     `Estado cambiado para objeto con id ${this.pedidosConEstadoSolicitud[i].id}: ${this.pedidosConEstadoSolicitud[i].solicitud}`
      //   );
      // }

      // this.AvanzandoPedidosBtn = false; //El btn se activa de nuevo

      try {
        // Creamos un array de promesas utilizando map para hacer una solicitud por cada pedido
        const promesasSolicitudes = this.pedidosConEstadoSolicitud.map(
          async (pedido) => {
            pedido.solicitud = "Procesando...";
            try {
              const avanzado = await this.avanzarPedidoEnArrayPreparado(pedido);
              if (avanzado) {
                pedido.solicitud = "Completado";
              } else {
                pedido.solicitud = "No completado";
              }
            } catch (error) {
              console.error("Error al avanzar pedido:", error);
              pedido.solicitud = "Error";
            }
          }
        );

        // Usamos Promise.allSettled para esperar a que todas las promesas se resuelvan o rechacen
        const resultados = await Promise.allSettled(promesasSolicitudes);

        console.log(resultados);
        this.selectedPedidos = [];

        await this.getPedidos();
        await this.obtenerArregloSucursalesDisponibles();
        this.AvanzandoPedidosBtn = false; //El btn se activa de nuevo
        this.mensajeroParaVariosPreparados = "";
      } catch (error) {
        console.error("Error al avanzar pedidos:", error);
        this.AvanzandoPedidosBtn = false;
        this.mensajeroParaVariosPreparados = "";
      }
    },
    async avanzarRutaEntregaVarios() {
      console.log(this.pedidosConEstadoSolicitud);
      this.dialogUsuariosGPSVarios = false;
      this.dialogProgresoAvanzarVarios = true;
      this.AvanzandoPedidosBtn = true; // Deshabilitar el botón

      // se comprueba el siguiente estado de los pedidos, si es 'en ruta de entrega' se abre un dialog para seleccionar el mensajero para cada pedido
      const siguienteEstado = this.getSiguienteEstado(
        this.pedidosConEstadoSolicitud[0]
      );

      try {
        // Creamos un array de promesas utilizando map para hacer una solicitud por cada pedido
        const promesasSolicitudes = this.pedidosConEstadoSolicitud.map(
          async (pedido) => {
            // pedido.solicitud = "Procesando...";
            try {
              const avanzado = await this.avanzarPedidoEnArray(
                pedido,
                siguienteEstado
              );
              if (avanzado) {
                pedido.solicitud = "Completado";
              } else {
                pedido.solicitud = "No completado";
              }
            } catch (error) {
              console.error("Error al avanzar pedido:", error);
              pedido.solicitud = "Error";
            }
          }
        );

        // Usamos Promise.allSettled para esperar a que todas las promesas se resuelvan o rechacen
        const resultados = await Promise.allSettled(promesasSolicitudes);

        console.log(resultados);
        this.selectedPedidos = [];

        await this.getPedidos();
        await this.obtenerArregloSucursalesDisponibles();
      } catch (error) {
        console.error("Error al avanzar pedidos:", error);
      }

      this.AvanzandoPedidosBtn = false; // Habilitar el botón
    },
    async avanzarVariosPedidos() {
      console.log("se avanzan los pedidos");
      // se le asigna el estado 'en espera...' a todos los pedidos. Ese estado se ira modificando comforme se avancen los pedidos
      const pedidosEstadoSolicitud = this.selectedPedidos.map((pedido) => {
        const pedidoEstadoSolicitud = { ...pedido };
        pedidoEstadoSolicitud.solicitud = "En espera...";
        return pedidoEstadoSolicitud;
      });
      this.pedidosConEstadoSolicitud = pedidosEstadoSolicitud;

      // se comprueba el siguiente estado de los pedidos, si es 'en ruta de entrega' se abre un dialog para seleccionar el mensajero para cada pedido
      const siguienteEstado = this.getSiguienteEstado(
        pedidosEstadoSolicitud[0]
      );
      if (siguienteEstado.value == "en_ruta_de_entrega") {
        // Utilizar el método filter para obtener un nuevo array con usuarios cuya sucursal sea la del pedido
        const mensajerosArray = this.usuarios.filter(
          (usuario) =>
            usuario.sucursal === pedidosEstadoSolicitud[0].sucursal &&
            usuario.gps !== null
        );
        console.log(mensajerosArray);

        this.mensajeros = mensajerosArray.map((mensajero) => ({
          text: mensajero.nombre,
          value: mensajero.id,
        }));

        this.dialogConfirmarAvanzarVarios = false;
        this.dialogUsuariosGPSVarios = true;
      } else {
        this.dialogConfirmarAvanzarVarios = false;
        this.dialogProgresoAvanzarVarios = true;
        this.AvanzandoPedidosBtn = true;

        // for (let i = 0; i < this.pedidosConEstadoSolicitud.length; i++) {
        //   // Cambiar el estado del objeto en el array
        //   this.pedidosConEstadoSolicitud[i].solicitud = "Procesando...";

        //   // Simular solicitud al backend esperando 5 segundos
        //   await new Promise((resolve) => setTimeout(resolve, 500));

        //   // Cambiar el estado del objeto en el array
        //   this.pedidosConEstadoSolicitud[i].solicitud = "Completado";

        //   // Imprimir el estado actual después de cambiarlo
        //   console.log(
        //     `Estado cambiado para objeto con id ${this.pedidosConEstadoSolicitud[i].id}: ${this.pedidosConEstadoSolicitud[i].solicitud}`
        //   );
        // }

        try {
          // Creamos un array de promesas utilizando map para hacer una solicitud por cada pedido
          const promesasSolicitudes = this.pedidosConEstadoSolicitud.map(
            async (pedido) => {
              pedido.solicitud = "Procesando...";
              try {
                const avanzado = await this.avanzarPedidoEnArray(
                  pedido,
                  siguienteEstado
                );
                if (avanzado) {
                  pedido.solicitud = "Completado";
                } else {
                  pedido.solicitud = "No completado";
                }
              } catch (error) {
                console.error("Error al avanzar pedido:", error);
                pedido.solicitud = "Error";
              }
            }
          );

          // Usamos Promise.allSettled para esperar a que todas las promesas se resuelvan o rechacen
          const resultados = await Promise.allSettled(promesasSolicitudes);

          console.log(resultados);
          this.selectedPedidos = [];

          await this.getPedidos();
          await this.obtenerArregloSucursalesDisponibles();
          if (siguienteEstado.value === "entregado") {
            this.$emit("pedidoEntregado");
          }
          this.AvanzandoPedidosBtn = false; //El btn se activa de nuevo
        } catch (error) {
          console.error("Error al avanzar pedidos:", error);
          this.AvanzandoPedidosBtn = false;
        }
      }
    },
    /* Metodo que se utiliza en avanzarVariosPedidos dentro de un ciclo para ir avanzando varios pedidos uno tras otro, regresa true si se avanza el pedido y false si hubo un error
      esto para que se pueda mostrar un icono dependiendo si se avanzo el pedido o no */
    async avanzarPedidoEnArray(pedido, nuevoEstado) {
      /* Si el estado actual del pedido es revision de credito, su siguiente estado es confirmacion,
        se hace directamente ya que el estado revision de credito no se encuentra en el orden de estados */
      if (pedido.estado === "Revisión de crédito") {
        try {
          const response = await axios.post(
            `/pedidos/avanzar_pedido?id_pedido=${pedido.id}&nuevo_estado=confirmacion`
          );
          console.log(response.data);
          //Se solicitan los pedidos para actualizar la tabla sin tener que recargar toda la view completa
          // await this.getPedidos();
          // await this.obtenerArregloSucursalesDisponibles();
          // if (nuevoEstado.value === "entregado") {
          //   this.$emit("pedidoEntregado");
          // }
          this.dialogConfirmarAvanzar = false;
          return true;
        } catch (error) {
          if (error.response.status === 401) {
            console.error(error.response);
          } else {
            console.error(error.response);
          }
          return false;
        }
      }
      //Si el siguiente estado del pedido es en_ruta_de_entrega, se tiene que agregar el mensajero en la solicitud
      else if (nuevoEstado.value == "en_ruta_de_entrega") {
        try {
          const response = await axios.post(
            `/pedidos/avanzar_pedido?id_pedido=${pedido.id}&nuevo_estado=en_ruta_de_entrega&mensajero_id=${pedido.nuevoMensajero}` //nuevoMensajero se asigna en dialogUsuariosGPSVarios
          );
          console.log(response.data);
          // alert("Pedido avanzado");
          // location.reload();
          //Se solicitan los pedidos para actualizar la tabla sin tener que recargar toda la view completa
          // await this.getPedidos();
          // await this.obtenerArregloSucursalesDisponibles();
          // if (nuevoEstado.value === "entregado") {
          //   this.$emit("pedidoEntregado");
          // }
          this.dialogConfirmarAvanzar = false;
          // this.$emit("pedidoModificado");
          return true;
        } catch (error) {
          if (error.response.status === 401) {
            console.error(error.response);
          } else {
            console.error(error.response);
          }
          this.dialogConfirmarAvanzar = false;
          return false;
        }
      } else {
        try {
          const response = await axios.post(
            `/pedidos/avanzar_pedido?id_pedido=${pedido.id}&nuevo_estado=${nuevoEstado.value}`
          );
          console.log(response.data);
          // alert("Pedido avanzado");
          // location.reload();
          //Se solicitan los pedidos para actualizar la tabla sin tener que recargar toda la view completa
          // await this.getPedidos();
          // await this.obtenerArregloSucursalesDisponibles();
          // if (nuevoEstado.value === "entregado") {
          //   this.$emit("pedidoEntregado");
          // }
          this.dialogConfirmarAvanzar = false;
          // this.$emit("pedidoModificado");
          return true;
        } catch (error) {
          console.error(error.response);
          this.dialogConfirmarAvanzar = false;
          return false;
        }
      }
    },
    async avanzarPedidoEnArrayPreparado(pedido) {
      //this.mensajeroParaVariosPreparado contiene el mensajero que se le asiganra a todos los pedidos seleccionados
      try {
        const response = await axios.post(
          `/pedidos/avanzar_pedido?id_pedido=${pedido.id}&nuevo_estado=en_ruta_de_entrega&mensajero_id=${this.mensajeroParaVariosPreparados}` //mensajeroParaVariosPreparado se asigna en dialogAgregarMensajeroAll
        );
        console.log(response.data);
        return true;
      } catch (error) {
        if (error.response.status === 401) {
          console.error(error.response);
        } else {
          console.error(error.response);
        }
        return false;
      }
    },
    confirmarAvanzarPedido(pedido) {
      // Comprobamos si el pedido que se quiere avanzar esta en el array de selectedPedidos
      const index = this.selectedPedidos.findIndex(
        (objeto) => objeto.id === pedido.id
      );

      // Si el pedido que se intenta avanzar existe en el array de selectedPedidos
      if (index !== -1) {
        //si hay mas de un pedido seleccionado se intentan avanzar juntos
        if (this.selectedPedidos.length > 1) {
          //se comprueba si todos los pedidos tienen el mismo estado
          if (this.pedidosMismoEstado(this.selectedPedidos)) {
            this.dialogConfirmarAvanzarVarios = true;
          }
          // al menos un pedido no tiene el mismo estado
          else {
            alert(
              "Todos los pedidos seleccionados deben tener el mismo estado para poder avanzarlos"
            );
          }
        }
        //si solo hay un pedido seleccionado se avanza normalmente
        else if (this.selectedPedidos.length === 1) {
          this.pedidoAvanzar = pedido;
          this.dialogConfirmarAvanzar = true;
        }
      }
      // Si no existe en el array de selectedPedidos, se intenta avanzar individualmente
      else {
        this.pedidoAvanzar = pedido;
        this.dialogConfirmarAvanzar = true;
      }
    },
    /* Verifica si todos los pedidos del array tienen el mismo estado */
    pedidosMismoEstado(pedidos) {
      // Si el array de pedidos está vacío, retornamos true
      if (pedidos.length === 0) {
        return true;
      }

      // Obtenemos el estado del primer pedido
      const primerEstado = pedidos[0].estado;

      // Verificamos si todos los estados son iguales al primer estado
      return pedidos.every((pedido) => pedido.estado === primerEstado);
    },
    currentItems: function (value) {
      this.itemsActuales = value;
      // console.log(this.itemsActuales);
    },
    filtrarItems() {
      const criterioBusqueda = this.search.toLowerCase();

      this.itemsFiltrados = this.itemsActuales.filter((item) => {
        // Aplica aquí tu lógica de filtrado según tus necesidades
        for (let prop in item) {
          const valor = item[prop];

          if (
            typeof valor === "string" &&
            valor.toLowerCase().includes(criterioBusqueda)
          ) {
            return true; // Si alguna propiedad coincide, se incluye el item en los resultados
          } else if (
            typeof valor === "number" &&
            valor.toString().toLowerCase().includes(criterioBusqueda)
          ) {
            return true; // Si el valor numérico coincide, se incluye el item en los resultados
          }
        }
        return false;
      });
    },
    async getComentarios() {
      let arrayFiltrado = [];

      if (this.itemsFiltrados.length === 0) {
        arrayFiltrado = this.itemsNombre[this.selectedTab].pedidos;
      } else {
        arrayFiltrado = this.itemsFiltrados;
      }

      try {
        // Creamos un array de promesas utilizando map para hacer una solicitud por cada pedido
        const promesasSolicitudes = arrayFiltrado.map(async (pedido) => {
          const response = await axios.get(
            `/varios/get_comentarios?id_objeto=${pedido.id}&tipo_objeto=pedido`
          );

          const comentarios = response.data;

          // Verifica si hay comentarios con más de un minuto de antigüedad
          const currentDate = new Date();
          if (comentarios.length > 0) {
            const ultimoComentario = comentarios[0];
            const fechaComentario = new Date(ultimoComentario.fecha_creacion);
            const diffMs = currentDate - fechaComentario;
            const diffMins = Math.floor(diffMs / (1000 * 60));
            //si el ultimo comentario tiene mas de un minuto, marcar el pedido como necesit revision
            const necesitaRevision = diffMins > 1;
            this.$set(pedido, "necesitaRevision", necesitaRevision);
          } else {
            //si no hay comentarios, marcar el pedido como no necesita revision
            this.$set(pedido, "necesitaRevision", false);
          }
          console.log(pedido.necesitaRevision);
          return comentarios;
          //return response.data; // Aquí puedes retornar la data específica que necesitas del response
        });

        // Resolvemos todas las promesas utilizando Promise.all
        const resultados = await Promise.all(promesasSolicitudes);

        // con resultados.flat() haces que el array sea de nivel 1 para no tener todos los comentarios anidados
        // console.log(resultados.flat());
        return resultados.flat();
      } catch (error) {
        console.error("Error al obtener los comentarios:", error);
      }
    },
    async getLocalizacion(idCliente) {
      try {
        // Creamos un array de promesas utilizando map para hacer una solicitud por cada pedido

        const response = await axios.get(`/reportes/localizacion/${idCliente}`);
        return response.data; // Aquí puedes retornar la data específica que necesitas del response
      } catch (error) {
        console.error("Error al obtener localizacion:", error);
        return {
          latitud: "",
          longitud: "",
        };
      }
    },
    filtrarComentariosPorIdObjeto(idObjeto, arrayComentarios) {
      // Utilizamos el método 'filter' para obtener los comentarios que coinciden con 'id_objeto'
      const comentariosFiltrados = arrayComentarios.filter(
        (comentario) => comentario.id_objeto === idObjeto
      );

      return comentariosFiltrados;
    },

    async actualizarPedidosARuta(ultimoFormato) {
      /*
        // Recuperar el último formato guardado
        const ultimoFormato = this.formatosImpresionGuardados.at(-1);*/

      if (!ultimoFormato || !ultimoFormato.pedidosPreparadosIDs) {
        alert("No se encontraron pedidos preparados en el formato.");
        return;
      }

      const pedidosPreparadosIDs = ultimoFormato.pedidosPreparadosIDs;
      console.log("Pedidos preparados:", pedidosPreparadosIDs);

      const idMensajero = ultimoFormato.idMensajero;
      console.log("Mensajero ID:", idMensajero);

      try {
        // Enviar los pedidos preparados a "ruta de entrega"
        await this.cambiarPedidosARuta(pedidosPreparadosIDs, idMensajero);
      } catch (error) {
        console.error("Error al enviar pedidos:", error);
        alert("Hubo un error al enviar los pedidos. Revisa la consola.");
      }
    },
    async cambiarPedidosARuta(pedidosPreparadosIDs, idMensajero) {
      let todosEnRuta = true;
      let errores = false;
      let mensajeExito = false;

      if (pedidosPreparadosIDs.length === 0) {
        alert(
          "Solo los pedidos preparados se pueden enviar a ruta de entrega."
        );
        return;
      }

      for (let idPedido of pedidosPreparadosIDs) {
        try {
          await axios.post("/pedidos/avanzar_pedido", null, {
            params: {
              id_pedido: idPedido, // ID del pedido preparado
              nuevo_estado: "en_ruta_de_entrega", // Estado deseado
              mensajero_id: idMensajero, // ID del mensajero
            },
          });
          mensajeExito = true;
          console.log(`Pedido ${idPedido} cambiado a ruta de entrega.`);
        } catch (error) {
          if (error.response && error.response.status === 400) {
            const errorMessage = error.response.data.detail;

            if (errorMessage.includes("Estado Actual: en_ruta_de_entrega")) {
              continue;
            } else {
              errores = true;
              console.error(
                `Error al actualizar pedido ${idPedido}:`,
                error.response?.data || error.message
              );
            }
          } else {
            errores = true;
            console.error("Error desconocido:", error);
          }
        }
      }

      if (mensajeExito) {
        alert(
          "Todos los pedidos preparados han sido enviados a la ruta de entrega exitosamente."
        );
      } else if (todosEnRuta) {
        alert("Todos estos pedidos preparados ya estan en ruta de entrega.");
      }

      if (errores) {
        alert("Hubo un error al enviar los pedidos.");
      }
    },

    async obtenerDatosSucursales() {
      try {
        const response = await axios.get(`/varios/get_json?nombre=sucursales`);
        this.sucursalesDirecciones = response.data.objeto;
        //console.log(this.sucursalesDirecciones);
      } catch (error) {
        console.error("Error al obtener los datos de las sucursales", error);
      }
    },
    async verificarLocalizaciones() {
      this.pedidosConLocalizacion = [];
      this.pedidosSinLocalizacion = [];
      let arrayFiltrado = this.itemsNombre[this.selectedTab].pedidos;

      //itemsFitrados contiene los pedidos que se muestran en la tabla
      if (this.itemsFiltrados.length === 0) {
        arrayFiltrado = this.itemsFiltrados;
      }

      // Se obtienen las localizaciones de todos los pedidos y se les asigna latitud y longitud
      const arrayLocalizaciones = await Promise.all(
        arrayFiltrado.map(async (item) => {
          const localizacion = item.localizacion || {};
          const nuevoItem = {
            id: item.id,
            estado: item.estado,
            fecha_creacion: this.formatoFecha(item.fecha_creacion),
            cliente: item.cliente,
            facturas: item.facturas.join("/"), // Unir las facturas en una sola cadena
            zona: item.zona,
            latitud: localizacion.latitud || "",
            longitud: localizacion.longitud || "",
            direccion:
              localizacion.direccion_linea_1 +
              ", " +
              localizacion.direccion_linea_2,
            codigo_postal: localizacion.codigo_postal,
            ciudad: localizacion.ciudad,
            descripcion: localizacion.descripcion || "",
            mensajero: item.mensajero,
            entregado: "",
            comentarios: "",
          };
          return nuevoItem;
        })
      );

      // console.log(arrayLocalizaciones);

      // Se filtran los pedidos con localizacion
      this.pedidosConLocalizacion = arrayLocalizaciones.filter((pedido) => {
        // Verificas si la propiedad 'latitud' existe y no está vacía (si tiene latitud entonces tambien tiene longitud)
        if (
          pedido.latitud !== undefined &&
          pedido.latitud !== null &&
          pedido.latitud !== ""
        ) {
          return true; // Mantienes el objeto en el array original
        } else {
          this.pedidosSinLocalizacion.push(pedido); // Agregas el objeto al array de eliminados
          return false; // Eliminas el objeto del array original
        }
      });

      console.log(this.pedidosConLocalizacion);
      console.log(this.pedidosSinLocalizacion);

      if (
        this.pedidosSinLocalizacion.length > 0 &&
        this.pedidosConLocalizacion.length > 0
      ) {
        this.dialogPedidosSinLocalizacion = true;
      } else if (
        this.pedidosSinLocalizacion.length === 0 &&
        this.pedidosConLocalizacion.length > 0
      ) {
        this.exportToCSV(this.pedidosConLocalizacion);
      } else if (this.pedidosConLocalizacion.length === 0) {
        alert("No hay pedidos con localizacion asignada");
      }
    },

    formatoPrecio(numero) {
      // Agregar console.log para ver qué valor está entrando
      //console.log("Número recibido:", numero);

      try {
        // Verificar si el número es válido
        if (isNaN(numero)) {
          console.error(
            "El valor proporcionado no es un número válido:",
            numero
          );
          return "$0.00";
        }

        const numeroPrecio = parseFloat(numero);
        const precio = numeroPrecio.toFixed(2); // Limitar a 2 decimales
        const separadorDecimal = precio.indexOf(".") !== -1 ? "." : "";
        const [parteEntera, parteDecimal] = precio.split(separadorDecimal);

        // Formatear la parte entera con separador de miles
        const parteEnteraFormateada = parteEntera.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ","
        );

        return `${parteEnteraFormateada}${separadorDecimal}${parteDecimal}`;
      } catch (error) {
        console.error("Error al formatear el número:", error);
        return "$0.00"; // En caso de error, devolver un valor por defecto
      }
      /*// Formatear el número utilizando una función personalizada
        const numeroPrecio = parseFloat(numero);
        const precio = numeroPrecio.toFixed(2); // Limitar a 2 decimales
        const separadorDecimal = precio.indexOf(".") !== -1 ? "." : "";
        const [parteEntera, parteDecimal] = precio.split(separadorDecimal);

        // Formatear la parte entera con separador de miles
        const parteEnteraFormateada = parteEntera.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ","
        );

        return `${parteEnteraFormateada}${separadorDecimal}${parteDecimal}`;*/
    },
    async pedidoModificado() {
      await this.getPedidos(); //Se solicitan los pedidos para actualizar la tabla sin tener que recargar la view completa
      await this.obtenerArregloSucursalesDisponibles();
      // this.$emit("pedidoModificado");
    },
    getSiguienteEstado(pedido) {
      if (pedido.estado === "Revisión de crédito") {
        return this.ordenEstados[1]; //Si esta en revision de credito regresa el estado de Confirmacion
      }
      const estadoEncontrado = this.ordenEstados.find(
        (estado) => estado.text === pedido.estado
      );

      if (estadoEncontrado !== undefined) {
        const indice = this.ordenEstados.indexOf(estadoEncontrado);
        return this.ordenEstados[indice + 1];
      }
    },
    async avanzarRutaEntrega() {
      try {
        const response = await axios.post(
          `/pedidos/avanzar_pedido?id_pedido=${this.pedidoEnRuta.id}&nuevo_estado=en_ruta_de_entrega&mensajero_id=${this.mensajero}` //this.mensajero contiene solo el id del mensajero
        );
        console.log(response.data);
        alert("Pedido avanzado");
        // location.reload();
        await this.getPedidos(); //Se solicitan los pedidos para actualizar la tabla sin tener que recargar toda la view completa
        await this.obtenerArregloSucursalesDisponibles();
        this.$emit("pedidoModificado");
        this.dialogUsuariosGPS = false;
      } catch (error) {
        console.error(error.response);
        alert(error.response.data.detail[0].msg);
        this.dialogUsuariosGPS = false;
      }
    },
    async avanzarPedido(pedido) {
      const nuevoEstado = this.getSiguienteEstado(pedido);
      if (pedido.estado === "Revisión de crédito") {
        try {
          const response = await axios.post(
            `/pedidos/avanzar_pedido?id_pedido=${pedido.id}&nuevo_estado=confirmacion`
          );
          console.log(response.data);
          alert("Pedido avanzado");
          // location.reload();
          //Se solicitan los pedidos para actualizar la tabla sin tener que recargar toda la view completa
          await this.getPedidos();
          await this.obtenerArregloSucursalesDisponibles();
          if (nuevoEstado.value === "entregado") {
            this.$emit("pedidoEntregado");
          }
          this.dialogConfirmarAvanzar = false;
          this.abrirDetallesConfirmacion = false;
          // this.$emit("pedidoModificado");
        } catch (error) {
          if (error.response.status === 401) {
            console.error(error.response);
            alert("No permitido\n" + error.response.data.detail);
          } else {
            console.error(error.response);
            alert("Error al avanzar el pedido\n" + error.response.data.detail);
          }
          this.dialogConfirmarAvanzar = false;
          this.abrirDetallesConfirmacion = false;
        }
      }
      //Si el siguiente estado del pedido es en_ruta_de_entrega, se abre un dialogo para seleccionar el mensajero
      else if (nuevoEstado.value == "en_ruta_de_entrega") {
        this.pedidoEnRuta = pedido;

        // Utilizar el método filter para obtener un nuevo array con usuarios cuya sucursal sea la del pedido
        const mensajerosArray = this.usuarios.filter(
          (usuario) =>
            usuario.sucursal === pedido.sucursal && usuario.gps !== null
        );
        console.log(mensajerosArray);

        this.mensajeros = mensajerosArray.map((mensajero) => ({
          text: mensajero.nombre,
          value: mensajero.id,
        }));

        this.dialogConfirmarAvanzar = false;
        this.abrirDetallesConfirmacion = false;
        this.dialogUsuariosGPS = true;
      } else {
        try {
          const response = await axios.post(
            `/pedidos/avanzar_pedido?id_pedido=${pedido.id}&nuevo_estado=${nuevoEstado.value}`
          );
          console.log(response.data);
          alert("Pedido avanzado");
          // location.reload();
          //Se solicitan los pedidos para actualizar la tabla sin tener que recargar toda la view completa
          await this.getPedidos();
          await this.obtenerArregloSucursalesDisponibles();
          if (nuevoEstado.value === "entregado") {
            this.$emit("pedidoEntregado");
          }
          this.dialogConfirmarAvanzar = false;
          this.abrirDetallesConfirmacion = false;
          // this.$emit("pedidoModificado");
        } catch (error) {
          if (error.response.status === 401) {
            console.error(error.response);
            alert("No permitido\n" + error.response.data.detail);
          } else {
            console.error(error.response);
            alert(error.response.data.detail);
          }
          this.dialogConfirmarAvanzar = false;
          this.abrirDetallesConfirmacion = false;
        }
      }
    },
    crearListaDiscrepancias(stringDiscrepancias) {
      const discrepanciasList = stringDiscrepancias.split(",");
      return discrepanciasList;
    },
    obtenerArregloSucursalesDisponibles() {
      console.log(this.itemsPedidos);
      const nuevoArreglo = this.itemsPedidos.sort((a, b) => {
        const indiceA = this.ordenSucursales.indexOf(a.sucursal);
        const indiceB = this.ordenSucursales.indexOf(b.sucursal);
        return indiceA - indiceB;
      });
      this.itemsSucursalesDisponibles = nuevoArreglo;
    },
    getNombreVendedor(vendedorId) {
      const vendedorEncontrado = this.usuarios.find(
        (usuario) => usuario.id === vendedorId
      );
      if (vendedorEncontrado) {
        return vendedorEncontrado.nombre + " ";
      }
      return "";
    },
    getNombreCliente(clienteId) {
      const clienteEncontrado = this.clientes.find(
        (cliente) => cliente.id === clienteId
      );
      if (clienteEncontrado) {
        return clienteEncontrado.razon_social + " ";
      }
      return "";
    },
    getZonaCliente(clienteId) {
      const clienteEncontrado = this.clientes.find(
        (cliente) => cliente.id === clienteId
      );
      if (clienteEncontrado) {
        if (clienteEncontrado.zona) {
          return clienteEncontrado.zona + " ";
        }
      }
      return "";
    },
    /**Busca el cliente por id en el arreglo de clientes y retorna su informacion */
    getInfoCliente(clienteId) {
      const clienteEncontrado = this.clientes.find(
        (cliente) => cliente.id === clienteId
      );
      if (clienteEncontrado) {
        return clienteEncontrado;
      }
      return null;
    },
    getAntiguedad(fecha_creacion) {
      const now = new Date();
      const fecha = new Date(fecha_creacion);
      const diffMs = now - fecha;
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      const diffHrs = Math.floor(
        (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

      if (diffDays > 0) {
        return `${diffDays} día${diffDays > 1 ? "s" : ""}`;
      } else if (diffHrs > 0) {
        return `${diffHrs} hora${diffHrs > 1 ? "s" : ""}`;
      } else if (diffMins > 0) {
        return `${diffMins} minuto${diffMins > 1 ? "s" : ""}`;
      } else {
        return `menos de un minuto`;
      }
    },
    async getPedidos() {
      try {
        const response = await axios.get(`/pedidos/get_abiertos`);
        this.itemsPedidos = response.data;
        this.$emit("pedidosActualizados", this.itemsPedidos); //Se envian los pedidos actualizados a la vista de PedidosView
      } catch (error) {
        console.error(error);
      }
    },
    formatoFecha(fechaOriginal) {
      // Fecha en el formato original

      // Crear un objeto Date a partir de la fecha original
      const fecha = new Date(fechaOriginal);

      // Obtener los componentes de la fecha
      const year = fecha.getFullYear();
      const month = ("0" + (fecha.getMonth() + 1)).slice(-2); // Agrega un cero inicial si es necesario
      const day = ("0" + fecha.getDate()).slice(-2); // Agrega un cero inicial si es necesario

      // Construir la fecha en el formato deseado
      const fechaFormateada = `${day}-${month}-${year}`;

      return fechaFormateada; // Resultado: '01-06-2023'
    },
    getFechaLegible(fechaOriginal) {
      const fecha = new Date(fechaOriginal);

      const año = fecha.getFullYear();
      const mes = fecha.getMonth() + 1;
      const dia = fecha.getDate();
      const hora = fecha.getHours();
      const minutos = fecha.getMinutes().toString().padStart(2, "0");

      const fechaLegible = `${dia}/${mes}/${año}`;
      const horaLegible = `${hora}:${minutos}`;

      return `${fechaLegible} ${horaLegible}`;
    },
    async getComentariosNuevos(periodo) {
      const currentDate = new Date();
      let fechaComentarios = "";

      switch (periodo) {
        case 1:
          fechaComentarios = format(
            subMinutes(currentDate, 15),
            "yyyy-MM-dd HH:mm:ssXX"
          );
          break;
        case 2:
          fechaComentarios = format(
            subHours(currentDate, 1),
            "yyyy-MM-dd HH:mm:ssXX"
          );
          break;
        case 3:
          fechaComentarios = format(
            subHours(currentDate, 4),
            "yyyy-MM-dd HH:mm:ssXX"
          );
          break;
        case 4:
          fechaComentarios = format(
            subHours(currentDate, 8),
            "yyyy-MM-dd HH:mm:ssXX"
          );
          break;
        case 5:
          fechaComentarios = format(
            subHours(currentDate, 12),
            "yyyy-MM-dd HH:mm:ssXX"
          );
          break;
        default:
          fechaComentarios = format(currentDate, "yyyy-MM-dd HH:mm:ssXX");
          break;
      }

      try {
        const response = await axios.get(
          `/varios/get_comentarios_nuevos?tipo_objeto=pedido&fecha=${fechaComentarios}`
        );
        this.arrayComentariosNuevos = response.data;
        this.dialogComentarios = false;
      } catch (error) {
        console.error(error);
        this.dialogComentarios = false;
      }
    },
    verCantidadPedidos() {
      // console.log(this.selectedItems);

      const estados = [
        "Pedido creado",
        "Revisión de crédito",
        "Confirmación",
        "Facturación",
        "Preparación en almacén",
        "Preparado",
        "En ruta de entrega",
      ];

      const contadores = estados.map((estado) => {
        return this.selectedItems.reduce((acumulador, pedido) => {
          return acumulador + (pedido.estado === estado ? 1 : 0);
        }, 0);
      });

      this.chartSeries = [
        {
          name: "Cantidad",
          data: contadores,
        },
      ];

      // console.log(contadores);
      this.dialogPedidos = true;
    },
  },
  computed: {
    ...mapGetters(["user", "currentUser"]),
    getFilteredUsuarios() {
      return this.usuarios.filter((user) => {
        return user.nombre_adminpaq !== null;
      });
    },
    // Obtiene el día actual de la semana
    currentDay() {
      const days = [
        "DOMINGO",
        "LUNES",
        "MARTES",
        "MIERCOLES",
        "JUEVES",
        "VIERNES",
        "SABADO",
      ];
      const today = new Date();
      return days[today.getDay()];
    },
    todosMensajerosSeleccionados() {
      // Verifica si todos los pedidos tienen un nuevo mensajero seleccionado
      const seleccionados = this.pedidosConEstadoSolicitud.every(
        (pedido) =>
          pedido.nuevoMensajero !== null && pedido.nuevoMensajero !== undefined
      );
      // console.log(seleccionados);
      return seleccionados;
    },
    itemsNombre() {
      return this.itemsSucursalesDisponibles.map((sucursal) => {
        const pedidos = sucursal.pedidos.map((pedido) => {
          const nuevoPedido = { ...pedido };
          const infoCliente = this.getInfoCliente(pedido.cliente); //se almacena la informacion del cliente
          nuevoPedido.vendedor = this.getNombreVendedor(pedido.vendedor);
          nuevoPedido.creado_por = this.getNombreVendedor(pedido.creado_por);
          nuevoPedido.mensajero = this.getNombreVendedor(pedido.mensajero);
          nuevoPedido.idCliente = pedido.cliente;
          // nuevoPedido.cliente = this.getNombreCliente(pedido.cliente);
          // nuevoPedido.zona = this.getZonaCliente(pedido.cliente);

          if (infoCliente) {
            nuevoPedido.cliente = infoCliente.razon_social + " ";
            if (infoCliente.zona) {
              nuevoPedido.zona = infoCliente.zona + " ";
            } else {
              nuevoPedido.zona = "";
            }
          } else {
            nuevoPedido.cliente = "";
            nuevoPedido.zona = "";
          }

          if (pedido.facturas) {
            if (pedido.facturas[0] === null) {
              nuevoPedido.facturas = [];
            }
          } else {
            nuevoPedido.facturas = [];
          }

          // if (pedido.serie_factura && pedido.folio_factura) {
          //   nuevoPedido.serie_folio =
          //     pedido.serie_factura + " " + pedido.folio_factura;
          // }
          if (pedido.discrepancias === null) {
            nuevoPedido.discrepancias = "Sin discrepancias";
          }
          if (pedido.contado) {
            nuevoPedido.pago = "Contado";
          } else {
            nuevoPedido.pago = "Crédito";
          }
          let estado = pedido.estado;
          switch (estado) {
            case "pedido_creado":
              estado = "Pedido creado";
              break;
            case "revision_de_credito":
              estado = "Revisión de crédito";
              break;
            case "confirmacion":
              estado = "Confirmación";
              break;
            case "facturacion":
              estado = "Facturación";
              break;
            case "preparacion_en_almacen":
              estado = "Preparación en almacén";
              break;
            case "preparado":
              estado = "Preparado";
              break;
            case "en_ruta_de_entrega":
              estado = "En ruta de entrega";
              break;
            case "entregado":
              estado = "Entregado";
              break;
            case "cancelado":
              estado = "Cancelado";
              break;
            default:
          }
          nuevoPedido.estado = estado;
          return nuevoPedido;
        });

        //Para colocar los pedidos con prioridad primero
        // Usamos sort() junto con un comparador personalizado
        pedidos.sort((a, b) => {
          // Primero, verificamos si 'a' tiene prioridad y 'b' no
          if (a.prioridad && !b.prioridad) {
            return -1; // 'a' va antes que 'b'
          }

          // Segundo, verificamos si 'b' tiene prioridad y 'a' no
          if (!a.prioridad && b.prioridad) {
            return 1; // 'b' va antes que 'a'
          }

          // En caso de que ambos tengan la misma prioridad o ambos no tengan prioridad,
          // se mantiene el orden actual.
          return 0;
        });

        // console.log(pedidos);
        return { ...sucursal, pedidos };
      });
    },
    selectedItems() {
      this.filtrarItems();
      if (this.selectedTab >= 1 && this.selectedTab <= 6) {
        return this.itemsNombre[this.selectedTab].pedidos;
      } else {
        return this.itemsNombre[this.selectedTab].pedidos || [];
      }
    },
    itemRowBackgroundPrioridad() {
      return (item) => {
        const estado = item.estado;
        //const prioridad = item.prioridad;
        //const necesita_Revision = item.necesitaRevision;
        let classes = "";

        /*if (necesita_Revision) {
          classes += "";
        } else {*/
        switch (estado) {
          case "Cancelado":
            classes += "red lighten-4";
            break;
          case "Revisión de crédito":
            classes += "deep-purple lighten-4";
            break;
          case "Facturación":
            classes += "teal lighten-4";
            break;
          case "En ruta de entrega":
            classes += "yellow lighten-4";
            break;
          case "Preparación en almacén":
            classes += "orange lighten-4";
            break;
          case "Preparado":
            classes += "blue lighten-4";
            break;
          case "Pedido creado":
            classes += "green lighten-4";
            break;
          case "Confirmación":
            classes += "light-green lighten-4";
            break;
          case "Entregado":
            classes += "indigo lighten-4";
            break;
          default:
            classes += "";
            break;
        }
        //}

        //console.log(`Pedido ID: ${item.id}, Clases: ${classes}`);
        return classes.trim(); // Elimina espacios en blanco al principio y al final
      };
    },
    itemRowBackground() {
      return (item) => {
        const estado = item.estado;
        switch (estado) {
          case "Cancelado":
            return "red lighten-4";
          case "Facturación":
            return "teal lighten-4";
          case "Revisión de crédito":
            return "deep-purple lighten-4";
          case "En ruta de entrega":
            return "yellow lighten-4";
          case "Preparación en almacén":
            return "orange lighten-4";
          case "Preparado":
            return "blue lighten-4";
          case "Pedido creado":
            return "green lighten-4";
          case "Confirmación":
            return "light-green lighten-4";
          case "Entregado":
            return "indigo lighten-4";
          default:
            return "";
        }
      };
    },

    todosProductosMarcados() {
      const productos =
        this.pedidoSeleccionado?.productos?.lista_productos || [];
      /*console.log("Productos:", productos);
      console.log(
        "Todos productos marcados:",
        productos.every(
          (p) => p.estado === "Valido" || p.estado === "No valido"
        )
      );*/
      return (
        productos.length > 0 &&
        productos.every(
          (p) => p.estado === "Valido" || p.estado === "No valido"
        )
      );
    },
  },
  watch: {
    selectedTab() {
      this.obtenerMensajeroConGps();
      console.log("Cambiando a la sucursal:", this.selectedTab);

      if (this.selectedPedidos.length > 0) {
        this.selectedPedidos = [];
      }
    },

    pedidoSeleccionado: {
      handler(nuevoPedido) {
        if (nuevoPedido && nuevoPedido.id) {
          this.obtenerComentariosDelPedido(nuevoPedido.id);
          this.inicializarProductos();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.obtenerArregloSucursalesDisponibles();
    this.getComentariosNuevos();
    this.getComentarios();
    //console.log(this.formatoPrecio(10000));
    this.obtenerMensajeroConGps();
    this.obtenerDatosSucursales();
    this.inicializarProductos();
  },
  async created() {
    // Establece un temporizador para llamar a getPedidos() cada cierto intervalo
    this.timer = setInterval(async () => {
      await this.getPedidos();
      await this.obtenerArregloSucursalesDisponibles();
      await this.getComentarios();
    }, 15000); // 15000 milisegundos = 15 segundos
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  components: { AccionesPedido },
};
</script>

<style>
.highlighted-row {
  outline: 2px solid rgb(237, 97, 97); /* Cambie el color y el estilo del borde según sus necesidades */
  box-shadow: inset 2px 0 0 rgb(237, 97, 97), inset -2px 0 0 rgb(237, 97, 97); /* Ajuste el color y tamaño según sus necesidades */
}

.pointer-disabled {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.4;
}
.neon-warning {
  outline: 2px solid rgb(237, 97, 97);
  animation: glow 1s ease-in-out infinite alternate;
}

@keyframes glow {
  from {
    box-shadow: inset 0 0 5px rgb(237, 97, 97);
  }
  to {
    box-shadow: inset 0 0 10px rgb(237, 97, 97);
  }
}
</style>
